// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBar_form__3H1hV","input":"SearchBar_input__1v26L","filter":"SearchBar_filter__2Xjlj"};